import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { BarChart } from "@mui/x-charts/BarChart";

export default function BarChartCard(props) {
  const {
    name,
    data,
    caption,
    onClick,
    height = 300,
    hiddenLegend = false,
  } = props;
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="column"
          sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
        >
          <Stack sx={{ justifyContent: "space-between" }}>
            <Stack
              direction="column"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography variant="h5" component="p">
                {name}
                {onClick && (
                  <IconButton onClick={onClick}>
                    <OpenInNewIcon></OpenInNewIcon>
                  </IconButton>
                )}
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {caption}
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ width: "100%", height: "100%" }}>
            <BarChart
              {...data}
              slotProps={{
                noDataOverlay: { message: "Please Select Product" },
                legend: { hidden: hiddenLegend },
              }}
              height={height}
            ></BarChart>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
